module.exports = __webpack_public_path__ + "img/ewm.68eb3ccc.png";